import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as HodActions from './hod.actions';
import { DEFAULT_HODS } from './hod.constants';

@Injectable()
export class HodEffects {
  private actions$ = inject(Actions);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HodActions.loadHods),
      map(() => HodActions.loadHodsSuccess({ hods: DEFAULT_HODS })),
      catchError((error) =>
        of(
          HodActions.loadHodsFailure({
            error: error?.message || 'Failed to load hods',
          })
        )
      )
    )
  );
}
